import { Type } from 'class-transformer';
import { UserAddressModel } from 'src/lib/services/utility/utility-models/address.model';
import { PagingSearchFieldArgument } from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import { StudentContactAttributes } from '../../students/contacts/student-contact-options.model';
import {
	RequestedInformationModel,
	RequestedInformationModel_ClassTransform_Type,
	StudentUpdateTrackerStatus,
} from '../../trackers/student-update-tracker.model';
import {
	ContactFieldPhoneModel,
	ContactFieldValueModel,
} from '../contact-field.model';
import {
	UserUpdateRequestModel,
	UserUpdateRequestModel_ClassTransform_Type,
} from './users-update-request.model';

export interface UserUpdateRequestProfileArgument {
	profile_first_name?: string;
	profile_last_name?: string;
	profile_middle_name?: string;
	profile_maiden_name?: string;
	profile_suffix?: string;
	profile_preferred_name?: string;
	profile_student_gender?: string;
	profile_field_race?: string;
	profile_field_ethnicity?: string;
	profile_city?: string;
	profile_state?: string;
	profile_user_title?: string;
	profile_about?: string;
	profile_intro_video?: string;
	profile_employee_id?: string;
	profile_pronunciation?: string;
}

export class UserUpdateRequestContactAddressArgument extends UserAddressModel {
	active?: boolean;
}

export interface UserUpdateRequestContactArgument {
	phone?: ContactFieldPhoneModel[];
	mailing_address?: UserUpdateRequestContactAddressArgument;
	physical_address?: UserUpdateRequestContactAddressArgument;
	email?: ContactFieldValueModel[];
	messenger?: ContactFieldValueModel[];
}

export interface UserUpdateRequestStudentArgument {
	dob?: Date;
	program?: string;
	attendance_class?: string;
	grade?: string;
	student_id?: string;
	state_id?: string;
	cohort_year?: string;
	courses_concurrent?: number;
	district_id?: string;
	calculated_grade?: number;
	graduation_plan_id?: number;
	track?: number;
	sr_pay_level?: number;
	sr_pay_level_notes?: string;
	more_other?: string;
	district_residence?: string;
	custom_district?: string;
	timezone?: string;
	throttle_status?: string;
	student_location?: string;
}

export interface UserUpdateRequestEnrollmentArgument {
	district_id?: string;
	state_id?: string;
}

export interface UserDataPersonalContactPhoneArgument {
	phone: number | string;
	is_primary: boolean;
	sms_blocked?: boolean;
	type?: string;
	sms?: boolean;
}

export interface UserUpdateRequestPersonalContactArgument {
	link_id?: number;
	name: string;
	relationship: string;
	phones?: UserDataPersonalContactPhoneArgument[];
	emails?: string[];
	attributes?: StudentContactAttributes[];
	url?: string;
	account_uid?: number;
	delete?: boolean;
}

export interface UserUpdateRequestUsersArgument {
	theme?: string;
	admin_type?: string[];
	title?: string;
	timezone?: string;
	student_theme?: string;
	mobile_theme?: string;
}
export interface UserUpdateRequestContactsArgument {
	personal?: UserUpdateRequestPersonalContactArgument[];
}

export interface UserUpdateRequestArgument {
	profile?: UserUpdateRequestProfileArgument;
	contact_field?: UserUpdateRequestContactArgument;
	student_data?: UserUpdateRequestStudentArgument;
	enrollment?: UserUpdateRequestEnrollmentArgument;
	contacts?: UserUpdateRequestContactsArgument;
	user?: UserUpdateRequestUsersArgument;
	proof_files?: Record<string, File>[];
}

export class UpdateUserRequestArgumentResponse {
	success: boolean;
	@Type(UserUpdateRequestModel_ClassTransform_Type)
	update_request: UserUpdateRequestModel;
}

export interface UserApproveRequestArgument {
	fields_to_approve?: {
		profile?: {
			profile_student_gender?: boolean;
			profile_first_name?: boolean;
			profile_middle_name?: boolean;
			profile_last_name?: boolean;
			profile_maiden_name?: boolean;
			profile_preferred_name?: boolean;
			profile_suffix?: boolean;
			profile_field_race?: boolean;
		};
		contact_field?: {
			phone?: boolean;
			physical_address?: boolean;
			mailing_address?: boolean;
		};
		student_data?: {
			dob?: boolean;
			cohort_year?: boolean;
			student_given_id?: boolean;
			language_home?: boolean;
			language_primary?: boolean;
		};
		contacts?: {
			personal: number[];
		};
		approvals?: UserApprovalModel[];
	};
	field_decisions?: {
		field_key: string;
		approved: boolean;
		rejection_message?: string;
		proof_decisions?: {
			proof_id: number;
			approved: boolean;
			description?: string;
			rejection_message?: string;
			expiration_timestamp?: number;
			file_type?: string;
		}[];
	}[];
}

export class StudentUpdateHistoryModel {
	request_id: number;
	field: string;
	@Type(RequestedInformationModel_ClassTransform_Type)
	requested: RequestedInformationModel;
	student: {
		uid: number;
		first_name: string;
		last_name: string;
	};
	proposed_value: string | Date | ContactFieldPhoneModel | UserAddressModel;
	current_value: string | Date | ContactFieldPhoneModel | UserAddressModel;
	status: StudentUpdateTrackerStatus;
	@Type(RequestedInformationModel_ClassTransform_Type)
	completed: RequestedInformationModel;
	proofs: { proof_id: number; url: string }[];
	rejection_message?: string;
}

export function StudentUpdateHistoryModel_ClassTransform_Type() {
	return StudentUpdateHistoryModel;
}

export class StudentUpdateHistoryResponseModel {
	count: number;
	@Type(StudentUpdateHistoryModel_ClassTransform_Type)
	results: StudentUpdateHistoryModel[];
}

export interface StudentUpdateHistorySearchArgument {
	field: PagingSearchFieldArgument;
	requested_on: PagingSearchFieldArgument;
	requested_by_name: PagingSearchFieldArgument;
	completed_on?: PagingSearchFieldArgument;
	completed_by_name?: PagingSearchFieldArgument;
	status: PagingSearchFieldArgument;
}

export interface UserApprovalModel {
	request_id: number;
	field_decisions: {
		field_key: string;
		approved: boolean;
		rejection_message?: string;
		proof_decisions?: {
			proof_id: number;
			approved: boolean;
			description?: string;
			rejection_message?: string;
			expiration_timestamp?: number;
			file_type?: string;
		}[];
	}[];
}
